import { DashboardServices } from "../../../services";
import {
  FETCH_DASHBOARD_ALL_RESERVATIONS,
  FETCH_DASHBOARD_DETAILS,
  FETCH_DASHBOARD_INIT,
  FETCH_V4_DASHBOARD,
  SET_DASHBOARD_LOCATIONS,
  TOAST,
} from "../../types/dashboard";

export const initializeDashboardScreen = () => ({ type: FETCH_DASHBOARD_INIT });

export const dashboardAllResFetchStart = (payload) => ({
  type: FETCH_DASHBOARD_ALL_RESERVATIONS.START,
  payload,
});
export const dashboardAllResFetchSuccess = (payload) => ({
  type: FETCH_DASHBOARD_ALL_RESERVATIONS.SUCCESS,
  payload,
});
export const dashboardAllResFetchError = (payload) => ({
  type: FETCH_DASHBOARD_ALL_RESERVATIONS.ERROR,
  payload,
});

export const showToast = (payload) => ({ type: TOAST, payload });

export const fetchDashboardAllReservations = (payload) => {
  return (dispatch) => {
    dispatch(dashboardAllResFetchStart(payload));
    DashboardServices.getDashBoardAllReservation(payload).then((data) => {
      if (!data.isError) {
        dispatch(dashboardAllResFetchSuccess(data));
      } else {
        dispatch(dashboardAllResFetchError(data));
      }
    });
  };
};

export const dashboardFetchStart = (payload) => ({
  type: FETCH_DASHBOARD_DETAILS.START,
  payload,
});

export const dashboardFetchSuccess = (payload) => ({
  type: FETCH_DASHBOARD_DETAILS.SUCCESS,
  payload,
});

export const dashboardFetchError = (payload) => ({
  type: FETCH_DASHBOARD_DETAILS.ERROR,
  payload,
});

export const fetchDashboardDetails = (payload) => (dispatch) => {
  dispatch(dashboardFetchStart(payload));

  DashboardServices.getDashBoardDetails(payload).then((data) => {
    if (!data.isError) {
      dispatch(dashboardFetchSuccess(data));
    } else {
      dispatch(dashboardFetchError(data));
    }
  });
};

export const setDashboardLocations = (locationIds) => ({
  type: SET_DASHBOARD_LOCATIONS,
  payload: locationIds,
});

export const fetchV4Dashboard = (locationIds = []) => {
  return (dispatch) => {
    dispatch({ type: FETCH_V4_DASHBOARD.START });
    DashboardServices.getV4Dashboard(locationIds).then((data) => {
      if (!data.isError && data.APIResult === 1) {
        dispatch({ type: FETCH_V4_DASHBOARD.SUCCESS, payload: data });
      } else {
        dispatch({ type: FETCH_V4_DASHBOARD.ERROR, payload: data });
      }
    });
  };
};
